module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0115.jpg?v=19ef9ef1";